import { Events, KeyCodes } from 'utils/Constants';

export default {

  props: ['clearSearch'],

  data: function() {
    return {
      isActive: false,
      search: '',
      currentIndex: 0
    }
  },

  created() {
    document.addEventListener(Events.CLICK, this.handleClickOutside);
    document.addEventListener(Events.KEYDOWN, e => this.handleResetKeydown(e));
  },

  destroyed() {
    document.removeEventListener(Events.CLICK, this.handleClickOutside);
    document.removeEventListener(Events.KEYDOWN, e => this.handleResetKeydown(e));
  },

  watch: {
    currentIndex: function (val) {
      if (this.currentIndex > this.filterSearch.length - 1) {
        this.currentIndex = 0;
      }
      else if(this.currentIndex < 0) {
        this.currentIndex = this.filterSearch.length - 1;
      }
      this.focusItem(this.currentIndex);
    },

    clearSearch: function (newValue, oldValue) {
      if (newValue && !oldValue) {
        this.search = '';
        this.$emit('search-value-changed', this.search);
      }
    }
  },

  methods: {

    /**
     * Handles keypresses on the search toggle.
     *
     * @method handleToggleKeydown
     * @param {Number} first index - The index of the first item in the array.
     * @public
     */
    handleToggleKeydown(index) {
      this.focusItem(0);
    },

    /**
     * Given a keycode, focuses the next relevant item.
     *
     * @method focusItem
     * @param {Number} currentIndex - The index of the currently selected item.
     * @public
     */
    focusItem(index) {
      const item = this.$refs.list.children[index].children[0];

      if (item) {
        item.focus();
      }
    },

    /**
     * Handles selection of an item from a click or keypress.
     *
     * @method handleItemSelected
     * @param {Object} event - Javascript event object
     * @public
     */
    handleItemSelected(e) {
      this.search = e.target.innerText;
      this.handleSubmit();
    },

    /**
     * Handles the event when clicking outside of the search area.
     *
     * Makes the search form inactive and clears the search term.
     * @param  {event} e [click event]
     * @return {void}
     */
    handleClickOutside(e) {
      if (this.isActive && !this.$el.contains(e.target) && this.$el !== e.target) {
        this.isActive = false;
        this.search = '';
      }
    },

  /**
   * Handles setting the form to inActive, when tabbing, only if there's nothing in the search input.
   *
   * @method handleBlur
   * @public
   */
    handleBlur() {
      if (!this.search) {
        this.isActive = false;
      }
    },

    /**
     * Handles setting the form back to inactive when the esc key is pressed
     *
     * @method handleBodyKeydown
     * @param  {event} e [keydown event]
     * @public
     */
    handleResetKeydown(e) {
      if (e.keyCode === KeyCodes.ESCAPE) {
        this.isActive = false;
        this.$refs.form.children[0].blur();
        this.search = '';
      }
    }
  }
}
